import React, { useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Marquee from "react-fast-marquee";

function BannerBottom() {

  const navigate = useNavigate()

  const [mobile, setMobile] = useState(window.innerWidth < 567 ? true : false)

  const tickets = [
    { text: "Customize Your Jerseys" },
    { text: "3D configuration jersey" },
    { text: "Fastest Delivery" },
    { text: "Customize Your Jerseys" },
    { text: "3D configuration jersey" },
    { text: "Fastest Delivery" },

  ]

  const settings = {
    infinite: true,
    adaptiveHeight: true,

    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 9000,             // long duration for smooth continuous effect
    autoplaySpeed: 0,        // remove pause between transitions
    cssEase: "linear",       // smooth linear movement

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };

  const settings1 = {
    infinite: true,
    adaptiveHeight: true,
    speed: 900,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,

    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };

  const offerImage = [
    { img: '/asset/img/Offer banner 1.jpg' },
    { img: "/asset/img/offer banner 2.jpg" },
    { img: "/asset/img/offer banner 3.jpg" },
    { img: "/asset/img/offer banner 4.jpg" },
    { img: "/asset/img/offer banner 5.jpg" },
    { img: "/asset/img/offer banner 6.jpg" },
    { img: "/asset/img/offer banner 7.jpg" }
  ]
  return (
    <div style={{ backgroundColor: "white" }}
    >

      <div
        className="col-12"
        data-cms-element-id="018ba954a62c7ab4baad156c58535517"

      >
        <p
          style={{ padding: mobile ? "8px" : "18px", fontWeight: mobile ? 600 : "", fontSize: mobile ? "20px" : "45px", fontFamily: 'Poppins, sans-serif', textAlign: mobile ? "center" : "center" }}>Hot & Cool Offers</p>

        {!mobile && <div style={{
          display: "flex", justifyContent: "center", gap: mobile ? "5px" : "40px", padding: mobile ? "4px" : "24px", marginBottom: "30px",
          margin: "1px", borderRadius: "20px", marginTop: "-30px",
        }}>

          <Slider {...settings1}> {
            offerImage.map(i =>
            (
              <div style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", borderRadius: "10px", margin: "5px" }}>
                <img src={i.img}
                  style={{ width: mobile ? "100%" : "100%" }} />
              </div>))
          }</Slider>


        </div>}


        {mobile &&
          <div style={{ display: "flex", overflowX: "auto", width: "100%", gap: "10px" }}>  {
            offerImage.map(i =>
            (
              <div style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", borderRadius: "10px", margin: "5px" }}>
                <img src={i.img} style={{ minWidth: mobile ? "80vw" : "320px" }} />
              </div>))
          }</div>
        }
      </div>

      <div style={{
        display: "flex", alignItems: "center", width: "100%", justifyContent: "space-around", paddingLeft: mobile ? "20px" : "50px", backgroundColor: "black",
        marginTop: mobile ? "25px" : "25px",
      }}>
        <div style={{
          position: "absolute", color: "white", backgroundColor: "black", width: mobile ? "100px" : "150px", height: mobile ? "40px" : "40px", paddingRight: "1px", paddingLeft: "10px", display: "flex", alignItems: "center",
          fontSize: mobile ? "12px" : "23px", zIndex: 100, left: mobile ? "20px" : "50px", fontWeight: 600, borderLeft: "4px solid yellow", borderBottomRightRadius: "10px",
        }}>
          FEATURED
        </div>


        <div style={{ width: "100%", background: "yellow", overflow: "hidden", height: mobile ? "40px" : "40px", }}>

          <Marquee
            speed={50}          // Adjust speed (higher = faster)
            gradient={false}    // Disable fade gradient at edges
            pauseOnHover={true} // Optional: pause on hover
            style={{ background: "yellow", width: "180%", height: "58px" }}
          >
            {
              tickets.map((ticket, index) => (
                <div key={index}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "yellow", height: mobile ? "60px" : "90px" }} >
                  <p style={{ fontSize: mobile ? "15px" : "20px", fontWeight: 500, backgroundColor: "yellow", height: mobile ? "40px" : "40px", display: "flex", alignItems: "center", justifyContent: "center", paddingRight: "50px" }}>{ticket.text}</p>
                </div>
              ))
            }

          </Marquee>

        </div>

      </div>

      <div
        onClick={() => navigate('/productListing/men/men-nft-football-jersey/men/NFL%20football/127/Jersey')}
        className="col-12"
        data-cms-element-id="018ba954a62c7ab4baad156c58535517"
        style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
      >
        <img src="\asset\img\Sh-banner-1.png" style={{ paddingTop: "50px", width: "100%" }} />


      </div>


    </div>
  );
}

export default BannerBottom;
